import styled from "@emotion/styled";
import { InputWrap, Label } from "shared/Input/styled";
import { ButtonWrap } from "shared/Button/styled";
import { colors } from "styles/colors";

export const IconWrap = styled.div``;

/* Style SearchWrap */
export const SearchWrap = styled.div`
  display: flex;
  align-items: center;

  ${IconWrap} {
    border-bottom: 1px ${colors.GREY_SEMILIGHT} solid;
    height: 46px;
    padding-top: 13px;
    .icon {
      stroke: ${colors.GREY} !important;
      fill: ${colors.GREY} !important;
    }
  }

  ${Label} {
    position: absolute;
    left: -999999px;
  }
  ${InputWrap} {
    flex: 1;
  }
  ${ButtonWrap} {
    padding: 9px;
    margin: 0;
    font-size: 0;
    .icon {
      margin: 0;
    }
    @media (min-width: 769px) {
      font-size: 1rem;
      padding: 9px 11px;
      .icon {
        margin-left: 10px;
      }
    }
  }
  ${InputWrap} + ${ButtonWrap} {
    margin-left: 10px;
    width: 46px;
    @media (min-width: 769px) {
      margin-left: 12px;
      width: auto;
    }
  }
`;
